module.exports = __webpack_public_path__ + "static/media/S (114).4230cccc.jpg";